import React from 'react'
import { RoleList } from './list/page'

export const RolesPage = (): JSX.Element => {
  return <RoleList />
}
